import Redemptions from '@/models/loyaltyPanel/Redemptions';
const getDefaultState = () => ({
  suppliers: [],
  gifts: [],
  allGifts: [],
  cancelGiftData: {},
  vouchers: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setSuppliers(state, payload) {
      state.suppliers = payload;
    },

    setGifts(state, payload) {
      state.gifts = payload;
    },

    setCancelGiftData(state, payload) {
      state.cancelGiftData = payload;
    },

    setAllGifts(state, payload) {
      state.allGifts = payload;
    },

    setVouchers(state, payload) {
      state.vouchers = payload;
    },
  },

  actions: {
    async fetchRedemptions({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        let query = '?page=' + body.page;

        if (body.query) {
          query += '&q=' + body.query;
        }

        if (body.status) {
          query += '&status=' + body.status;
        }

        if (body.supplier_id) {
          query += '&store_supplier_id=' + body.supplier_id;
        }

        const { data } = await Redemptions.get(query);
        const { transactions, pagination } = data.data;
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setGifts', transactions);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async fetchVouchers({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Redemptions.getVouchers(query);
        const { transactions, pagination } = data.data;
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setVouchers', transactions);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async fetchAllGifts({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Redemptions.getAllGifts(query);
        const { pending_gifts, pagination } = data.data;
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setAllGifts', pending_gifts);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async fetchAllGiftsByCustomer({ commit }, { user_account_id, page }) {
      try {
        commit('setLoading', true, { root: true });

        const query = `?page=${page || 1}`;
        const { data } = await Redemptions.getAllGiftsByCustomer(user_account_id, query);
        const { pending_gifts, pagination } = data.data;
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setAllGifts', pending_gifts);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getSuppliers({ commit }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Redemptions.getSuppliers();
        const suppliers = data.data;
        commit('setSuppliers', suppliers);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async cancelGift({ commit }, id) {
      try {
        commit('setLoading', true, { root: true });
        await Redemptions.cancelGift(id);

        commit('setCancelGiftData', {});
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
      }
    },
  },
};
